import { numberField } from '@/common/utils/form/fieldTypes';

export const sync_onboard_crew_documents_chunk_size = 'sync_onboard.crew_documents.chunk_size';
export const sync_onboard_crew_documents_delete_limit_per_case =
  'sync_onboard.crew_documents.delete_limit_per_case';

export type OnboardSyncType = {
  [sync_onboard_crew_documents_chunk_size]: string;
  [sync_onboard_crew_documents_delete_limit_per_case]: string;
};

const config = {
  [sync_onboard_crew_documents_chunk_size]: numberField(),
  [sync_onboard_crew_documents_delete_limit_per_case]: numberField()
};

export default config;
